// extracted by mini-css-extract-plugin
export var skipAnimation = "_17-0";